import { ComingSoonFeatureInterest } from 'types/comingSoonFeatures';

import axios from '../config/axiosPrivate';

export const COMING_SOON_INTERESTS_QUERY_KEY = 'coming-soon-feature-interests';

export const getComingSoonFeatureInterests = async (): Promise<ComingSoonFeatureInterest[]> => {
  const response = await axios.get('/recommendations/coming-soon-feature-interests/');
  return response.data;
};

export const createComingSoonFeatureInterest = async (payload: {
  feature: string;
  communities: number[];
  note: string;
}) => {
  const response = await axios.post('/recommendations/coming-soon-feature-interests/', payload);
  return response.data;
};
